<template id="view-documents">
  <div class="container-fluid">
    <div
      id="dialogDocuments"
      style="text-align: left; z-index: 2000 !important"
    >
      <documents-form
        :showing="dlgShow"
        :formAction="formAction"
        :isMobile="isMobile"
        :formData="rowData"
        @formClosed="hideForm"
        @onDataChange="fetchData"
      >
      </documents-form>
    </div>

    <div class="row top-row">
      <div class="col-12">
        <h3>Documentos</h3>
      </div>
    </div>
    <div class="row">
      <grid-component
        ref="lstGridDocumentos"
        gridName="Documentos"
        :hasRecharge="true"
        @reloadData="reloadData"
        @addNew="addDocument"
        @viewData="viewDocument"
        @editData="editDocument"
        @deleteData="deleteDocument"
        @duplicateData="duplicateDocument"
      >
      </grid-component>
    </div>
  </div>
</template>

<script>
/*Imports de VueJS*/
import Vue from "vue";
import { FormActionEnum } from "../../services/enums.js";
import GridComponent from "../shared/GridComponent.vue";
import DocumentsForm from "./DocumentsForm.vue";
import PermissionMixin from "../../mixins/PermissionMixin";
import ToastMixin from "../../mixins/ToastMixin";
// import CultureMixin from "../../mixins/CultureMixin";

/*Imports de Syncfusion*/
import { Browser } from "@syncfusion/ej2-base";
import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
import { DialogUtility } from "@syncfusion/ej2-popups";
import { TooltipPlugin } from "@syncfusion/ej2-vue-popups";

Vue.use(ButtonPlugin);
Vue.use(TooltipPlugin);

export default Vue.extend({
  name: "Documentos",
  props: {},
  mixins: [PermissionMixin, ToastMixin],
  components: { GridComponent, DocumentsForm },
  created() {
    this.formAction = FormActionEnum.LIST;
  },
  async mounted() {
    this.$parent.showLoading();
    //this.dataList = this.documentsList;
    this.columnsList = this.getcolumnsList();
    await this.fetchData();
    this.$parent.hideLoading(500);
  },
  updated() {},
  computed: {
    documentsList() {
      var list = this.$store.getters["documents/allDocuments"];

      var salida = [];
      list.forEach((item) => {
        let i = Object.assign({}, JSON.parse(JSON.stringify(item)));
        i.activeName = i.isActive ? "Activo" : "Inactivo";
        salida.push(i);
      });
      return salida;
    },
    rowData() {
      return this.$store.getters["documents/currentDocument"];
    },
    formData() {
      return JSON.parse(JSON.stringify(this.rowData));
    }
  },
  data() {
    return {
      dlgShow: false,
      formAction: FormActionEnum.LIST,
      isMobile: Browser.isDevice,
      deleteDialog: {},
      columnsList: [],
      toolTip: "",
      filter: { type: "CheckBox" },
      selectionSettings: { persistSelection: true },
      query: "",
      cuenta: 0,
      dataList: []
    };
  },
  provide: {},
  methods: {
    async reloadData() {
      this.$parent.showLoading();
      await this.fetchData();
      this.$parent.hideLoading(500);
    },
    async fetchData() {
      await this.$store.dispatch("documents/getDocuments");
      this.$store.dispatch("documents/initDocument");
      this.dataList = this.documentsList;
      var cols = JSON.parse(JSON.stringify(this.columnsList));
      this.$refs.lstGridDocumentos.setGridData(this.dataList, cols);
      this.cuenta++;
    },
    getcolumnsList() {
      var commandsList = JSON.parse(JSON.stringify(this.commands));
      if (this.hasPermission("CanCreate")) {
        commandsList.push({
          type: "Duplicar",
          buttonOption: {
            iconCss: "e-icons e-copy inline-command",
            cssClass: "e-flat e-noback duplicar",
            click: this.duplicateTool_click
          }
        });
      }
      let arrayColumns = [
        { field: "id", headerText: "Id Papirus" },
        { field: "name", headerText: "Nombre", clipMode: "EllipsisWithTooltip" },
        {
          field: "useCustomNaming",
          headerText: "Nombre Personalizado",
          displayAsCheckBox: true,
          clipMode: "EllipsisWithTooltip"
        },
        { field: "pageLimit", headerText: "Límite de Páginas" },
        { field: "formatsQuantity", headerText: "Cantidad de Formatos" },
        {
          field: "onePdfPerPage",
          headerText: "Un PDF por Hoja",
          displayAsCheckBox: "true"
        },
        {
          field: "activeName",
          headerText: "Activo",
          width: "150",
          minWidth: "150"
        },
        {
          headerText: "Acciones",
          commands: JSON.parse(JSON.stringify(commandsList))
        }
      ];
      return arrayColumns;
    },
    addDocument() {
      // this.dlgShow = !this.dlgShow;
      this.$store.dispatch("documents/initDocument");
      this.formAction = FormActionEnum.ADD;
      this.showForm();
    },
    viewDocument(rowData) {
      this.formAction = FormActionEnum.VIEW;
      this.showForm(rowData);
    },
    editDocument(rowData) {
      this.formAction = FormActionEnum.EDIT;
      this.showForm(rowData);
    },
    deleteDocument(rowData) {
      let hasRowData = !!rowData;
      if (hasRowData) {
        rowData.active = false;
        this.getDeleteConfirmation(rowData);
      }
    },
    duplicateDocument(rowData) {
      this.formAction = FormActionEnum.DUPLICATE;
      this.showForm(rowData);
    },
    async InactivateRow() {
      try {
        var localData = JSON.parse(JSON.stringify(this.deleteDialog.data));
        localData.isActive = false;
        await this.$store.dispatch("documents/deleteDocument", localData);
        // await this.$store.dispatch("documents/getDocuments");
        // this.dataList = this.documentsList;
        this.fetchData();
        this.showToast(
          "Confirmación",
          `Documento ${localData.name}  Desactivado`,
          2000
        );
      } catch (error) {
        console.log(error);
      }
      this.deleteDialog.data = {};
      this.deleteDialog.hide();
    },
    getDeleteConfirmation(row) {
      this.deleteDialog = DialogUtility.confirm({
        title: "Inactivar Documento",
        zindex: 1010,
        content: `Confirma que desea inactivar el Documento: ${row.name}`,
        okButton: {
          text: "Inactivar",
          click: this.InactivateRow,
          isPrimary: true
        },

        cancelButton: { text: "Cancelar" },
        showCloseIcon: false,
        closeOnEscape: false,
        animationSettings: { effect: "Zoom" }
      });
      this.deleteDialog.data = row;
      this.deleteDialog.show();
    },
    getAlertDialog(title, content) {
      let dialog = DialogUtility.alert({
        title: title,
        zindex: 1010,
        content: content,
        showCloseIcon: true,
        closeOnEscape: true,
        animationSettings: { effect: "Zoom" }
      });
      return dialog;
    },
    showForm(data) {
      try {
        let hasData = !!data;
        if (hasData) {
          this.$store.dispatch("documents/setDocument", data);
        }
      } catch (error) {
        console.log(error);
      }
      this.dlgShow = true;
    },
    hideForm() {
      this.dlgShow = false;
    }
  }
});
</script>
<style>
@import url(../../../node_modules/@syncfusion/ej2-base/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-notifications/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-buttons/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-inputs/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-popups/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-navigations/styles/fabric.css);
@import url(../../../node_modules/vue-loading-overlay/dist/vue-loading.css);

.e-alert-dialog.e-dialog.e-popup,
.e-confirm-dialog.e-dialog.e-popup {
  margin: auto !important;
}
.content-wrapper {
  width: 100%;
  margin: 15px auto;
  min-width: 185px;
}
@media only screen and (max-width: 480px) {
  .content-wrapper {
    width: 92%;
  }
}
.e-add-icon {
  background-repeat: no-repeat;
}
</style>
